import type { JSX } from 'react'
import type { IDropdownItemNoClickableProps } from 'blocks/Dropdown/DropdownItems/DropdownItemNoClickable'

import { TextBoxColors } from 'atoms/TextBox'
import { DropdownItemNoClickable } from 'blocks/Dropdown/DropdownItems/DropdownItemNoClickable'
import { TextBlockAccountUsername } from 'blocks/TextBlock/Templates'

export interface IDropdownItemUsername extends IDropdownItemNoClickableProps {
  title: string
  description: string
  colorTitle?: TextBoxColors
  colorDescription?: TextBoxColors
}

export const DropdownItemUsername = ({
  title,
  description,
  colorTitle = TextBoxColors.TEXT_ICON_PRIMARY,
  colorDescription = TextBoxColors.TEXT_ICON_SECONDARY,
  ...rest
}: IDropdownItemUsername): JSX.Element | null => {
  const conditionRender = title || description

  if (conditionRender)
    return (
      <DropdownItemNoClickable {...rest}>
        <TextBlockAccountUsername
          title={title}
          description={description}
          colorTitle={colorTitle}
          colorDescription={colorDescription}
        />
      </DropdownItemNoClickable>
    )

  return null
}
